import React from "react";
import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./AccessibleLink.css";

/**
 * Accessible link wrapper for WCAG 2.1 AA.
 * Adds localized screen-reader text for external / tel / mailto / map links.
 */
const AccessibleLink = ({
    href,
    children,
    className,
    sx,
    color,
    external = false,
    kind = "default",
    underline = "none",
    "aria-label": ariaLabel,
    ...rest
}) => {
    const { t } = useTranslation(["translation"]);
    const opensInNewTab = external || kind === "map";

    const getHiddenPrefix = () => {
        switch (kind) {
            case "tel":
                return t("callNumber");
            case "mailto":
                return t("sendEmailTo");
            case "map":
                return t("viewOnMapOpensInNewTab");
            default:
                return null;
        }
    };

    const hiddenPrefix = getHiddenPrefix();
    const showExternalHint = opensInNewTab && kind !== "map";

    return (
        <Link
            href={href}
            className={className}
            sx={sx}
            color={color}
            underline={underline}
            target={opensInNewTab ? "_blank" : undefined}
            rel={opensInNewTab ? "noopener noreferrer" : undefined}
            aria-label={ariaLabel}
            {...rest}
        >
            {hiddenPrefix && (
                <span className="visually-hidden">{hiddenPrefix}</span>
            )}
            {children}
            {showExternalHint && (
                <span className="visually-hidden">{t("opensInNewTab")}</span>
            )}
        </Link>
    );
};

export default AccessibleLink;
